import Link from 'next/link';
import Image from 'next/image';
import { ReactNode } from 'react';

interface AuthLayoutProps {
    children: ReactNode;
    title?: string;
    subtitle?: string;
}

export default function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            {/* Background */}
            <div className="absolute inset-0 z-0">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-secondary/10" />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(59,130,246,0.05),transparent_50%)]" />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(139,92,246,0.05),transparent_50%)]" />
            </div>

            {/* Content */}
            <div className="w-full max-w-md z-10">
                {/* Logo */}
                <div className="text-center mb-8">
                    <Link href="/" className="inline-flex flex-col items-center gap-3 group">
                        <div className="relative">
                            <div className="absolute inset-0 bg-purple-500/30 rounded-2xl blur-xl group-hover:blur-2xl transition-all duration-300" />
                            <Image
                                src="/images/logo-icon.png"
                                alt="Venntix"
                                width={80}
                                height={80}
                                className="relative h-20 w-20 object-contain drop-shadow-lg"
                                priority
                            />
                        </div>
                        <span className="font-black text-4xl bg-gradient-to-r from-purple-400 via-violet-400 to-purple-500 bg-clip-text text-transparent tracking-tight">
                            Veentix
                        </span>
                    </Link>
                    {title && (
                        <h2 className="text-2xl font-semibold mt-4 mb-2">{title}</h2>
                    )}
                    {subtitle && (
                        <p className="text-muted-foreground">{subtitle}</p>
                    )}
                </div>

                {/* Card */}
                <div className="bg-card border border-border rounded-lg shadow-lg p-6 md:p-8">
                    {children}
                </div>

                {/* Footer */}
                <div className="text-center mt-6 text-sm text-muted-foreground">
                    <p>
                        By continuing, you agree to our{' '}
                        <Link href="/terms" className="text-primary hover:underline">
                            Terms of Service
                        </Link>{' '}
                        and{' '}
                        <Link href="/privacy" className="text-primary hover:underline">
                            Privacy Policy
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}
